/** Extract the public relation summary from a failed delete/archive request. */
export const getDeleteDependencies = (error) => {
  const dependencies = error?.errors?.dependencies
  if (!Array.isArray(dependencies)) return []
  return dependencies
    .filter((entry) => typeof entry?.service === 'string' && entry.service.length > 0 && Number.isInteger(entry.count) && entry.count > 0)
    .map(({ service, count }) => ({ service, count }))
}
